<template>
  <!--<div id="allmap" style="width: 100%; height: {{mapHeight}}px"></div>-->
  <!--<div id="allmap":style="{width: '100%', height: mapHeight + 'px'}"></div>-->
  <div id="allmap" v-bind:style="mapStyle"></div>
</template>

<script>
export default {
  name: 'BMapComponent',
  data: function() {
    return {
      mapStyle: {
        width: '100%',
        height: this.mapHeight + 'px'
      }
    }
  },
  props: {
    // 地图在该视图上的高度
    mapHeight: {
      type: Number,
      default: 500
    }
  },
  mounted() {
    // 创建和初始化地图函数：
    function initMap() {
      createMap() // 创建地图
      setMapEvent() // 设置地图事件
      addMapControl() // 向地图添加控件
      addMapOverlay() // 向地图添加覆盖物
    }
    function createMap() {
      map = new BMap.Map('allmap')
      map.centerAndZoom(new BMap.Point(118.822906, 32.125430), 16)
    }
    function setMapEvent() {
      map.enableScrollWheelZoom()
      map.enableKeyboard()
      map.enableDragging()
      map.enableDoubleClickZoom()
    }
    function addClickHandler(target, window) {
      target.addEventListener('click', function() {
        target.openInfoWindow(window)
      })
    }
    function addMapOverlay() {
      var markers = [{ content: '东南大学国家大学科技园科创楼', title: '南京知车君网络科技有限公司', imageOffset: { width: 0, height: 3 }, position: { lat: 32.125430, lng: 118.822906 } }]
      for (var index = 0; index < markers.length; index++) {
        var point = new BMap.Point(markers[index].position.lng, markers[index].position.lat)
        var marker = new BMap.Marker(point, {
          icon: new BMap.Icon('http://api.map.baidu.com/lbsapi/createmap/images/icon.png', new BMap.Size(20, 25), {
            imageOffset: new BMap.Size(markers[index].imageOffset.width, markers[index].imageOffset.height)
          })
        })
        var label = new BMap.Label(markers[index].title, { offset: new BMap.Size(25, 5) })
        var opts = {
          width: 200,
          title: markers[index].title,
          enableMessage: false
        }
        var infoWindow = new BMap.InfoWindow(markers[index].content, opts)
        marker.setLabel(label)
        addClickHandler(marker, infoWindow)
        map.addOverlay(marker)
      }
    }
    // 向地图添加控件
    function addMapControl() {
      var scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_LEFT })
      scaleControl.setUnit(BMAP_UNIT_IMPERIAL)
      map.addControl(scaleControl)
      var navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_TOP_LEFT, type: BMAP_NAVIGATION_CONTROL_LARGE })
      map.addControl(navControl)
      var overviewControl = new BMap.OverviewMapControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT, isOpen: true })
      map.addControl(overviewControl)
    }
    var map
    initMap()
  }
}
</script>

<style scoped></style>
